;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGroupOrbOpen = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 200,
  height: 226,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#groupOrbOpen_svg__a)",
  d: "M200 111.695C200 223.39 200 226 100.518 226S0 221.824 0 111.695C0 3.132 0 0 100 0c96.891 0 100 0 100 111.695"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#groupOrbOpen_svg__b)",
  d: "M200 111.695C200 223.39 200 226 100.518 226S0 221.824 0 111.695C0 3.132 0 0 100 0c96.891 0 100 0 100 111.695"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#092C3C",
  strokeOpacity: 0.03,
  d: "M199.5 111.695c0 27.935-.001 49.011-1.552 64.933-1.552 15.93-4.65 26.596-10.764 33.781-6.101 7.17-15.281 10.96-29.223 12.943-13.948 1.984-32.561 2.148-57.443 2.148-24.88 0-43.558-.262-57.6-2.368-14.038-2.104-23.352-6.039-29.585-13.311-6.245-7.286-9.47-18.004-11.12-33.857C.566 160.118.5 139.237.5 111.695c0-27.152 0-47.673 1.56-63.202C3.62 32.956 6.733 22.52 12.877 15.465c6.133-7.043 15.364-10.8 29.38-12.784C56.279.697 74.99.5 100 .5c24.236 0 42.56 0 56.439 1.741 13.875 1.74 23.203 5.209 29.528 12.06 6.333 6.86 9.734 17.198 11.537 32.878 1.801 15.673 1.996 36.585 1.996 64.516Z"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "groupOrbOpen_svg__b",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "rotate(49.79 -47.564 127.445)scale(99.1454 99.0273)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0.09
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "groupOrbOpen_svg__a",
  x1: 101.024,
  x2: 101.024,
  y1: 53.834,
  y2: 187.376,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F8FFD1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A0ECFF"
})))));
export default SvgGroupOrbOpen;